import { Component } from "react"
import PropTypes from "prop-types"
import isEmpty from "lodash/isEmpty"
import find from "lodash/find"
import keys from "lodash/keys"
import EndpointTestAssertions from "partners/components/endpoint_test/assertions"
import EndpointTestCaseMessage from "partners/components/endpoint_test/test_case_message"
import { post } from "shared/lib/api"

export default class AuthenticationTestRetrieveUserInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isShowing: false,
      status: "initial",
      errorMessage: "Could not get user info, please try again.",
      assertions: [],
      APIToken: "",
    }
    this.getStatusClass = this.getStatusClass.bind(this)
    this.requestUserInfo = this.requestUserInfo.bind(this)
    this.toggle = this.toggle.bind(this)
  }

  componentDidMount() {
    this.tokensReceivedListener = window.addEventListener("tokensReceived", event => {
      if (event.detail.accessToken) {
        this.setState({
          accessToken: event.detail.accessToken,
          refreshToken: event.detail.refreshToken,
        })
        this.requestUserInfo(event.detail.accessToken)
      }
    })
  }

  componentWillUnmount() {
    window.removeEventListener("tokensReceived", this.tokensReceivedListener)
  }

  handleTokenChange = event => {
    this.setState({ APIToken: event.target.value })
  }

  getStatusClass() {
    if (this.state.status === "completed" && !isEmpty(this.state.assertions)) {
      return find(this.state.assertions, assertion => assertion.status === "failing") ? "failing" : "passing"
    }
    return ""
  }

  requestUserInfo(accessToken) {
    const requestParams = {}
    if (accessToken) {
      requestParams.oauth_access_token = accessToken
    } else if (this.state.APIToken && this.props.service.authentication_type === "api_token_auth") {
      requestParams.api_token = this.state.APIToken
    }
    this.setState({ status: "working" })
    post(this.props.path, requestParams)
      .then(response => {
        const request = response.data.request
        const statusCode = response.data.response.statusCode
        let body = response.data.response.body
        try {
          body = JSON.parse(body)
        } catch (e) {} // eslint-disable-line no-empty
        const assertions = {
          status_code_200: {
            label: "Status Code is 200",
            status: statusCode === 200 ? "passing" : "failing",
          },
          body_valid_json: {
            label: "Body is valid JSON",
            status: body && keys(body).length ? "passing" : "failing",
          },
          one_data_object: {
            label: 'Response has one top-level "data" object',
            status: body?.data && typeof body.data === "object" ? "passing" : "failing",
          },
          name_provided: {
            label: '"name" is a string',
            status: body?.data?.name && typeof body.data.name === "string" ? "passing" : "failing",
          },
          id_provided: {
            label: '"id" is a string',
            status: body?.data?.id && typeof body.data.id === "string" ? "passing" : "failing",
          },
        }
        this.setState(
          {
            assertions,
            request,
            response: response.data.response,
            status: "completed",
          },
          () => {
            window.dispatchEvent(
              new CustomEvent("statusReceived", {
                detail: {
                  componentKey: "retrieveUserInfo",
                  componentStatus: this.getStatusClass(),
                },
              })
            )
            if (["oauth_refresh_token", "oauth_pkce_refresh_token"].includes(this.props.service.authentication_type)) {
              window.dispatchEvent(
                new CustomEvent("userInfoReceived", {
                  detail: {
                    accessToken: this.state.accessToken,
                    refreshToken: this.state.refreshToken,
                  },
                })
              )
            }
          }
        )
      })
      .catch(response => {
        let errorMessage = this.state.errorMessage
        if (response.responseText) {
          try {
            errorMessage = JSON.parse(response.responseText).data.error.code
          } catch (e) {} // eslint-disable-line no-empty
        }
        this.setState({ status: "error", errorMessage })
        window.dispatchEvent(
          new CustomEvent("statusReceived", {
            detail: {
              componentKey: "retrieveUserInfo",
              componentStatus: "failing",
            },
          })
        )
      })
  }

  toggle() {
    this.setState({ isShowing: !this.state.isShowing })
  }

  render() {
    const statusClass = this.getStatusClass()
    return (
      <>
        {this.props.service.authentication_type === "api_token_auth" && (
          <span className="api-token">
            <input
              type="text"
              name="token"
              placeholder="api_token"
              value={this.state.APIToken}
              onChange={this.handleTokenChange}
            />
            <button
              className="button button-tertiary"
              onClick={() => this.requestUserInfo()}
              disabled={this.state.status === "working"}
            >
              Run test
            </button>
          </span>
        )}
        <div className={`endpoint publish-item ${statusClass} ${this.state.isShowing ? "expanded" : "collapsed"}`}>
          <header onClick={this.toggle}>Retrieve user information</header>
          {this.state.isShowing && (
            <div>
              {this.state.status === "completed" && (
                <>
                  <EndpointTestCaseMessage type="request" message={this.state.request} />
                  <EndpointTestCaseMessage type="response" message={this.state.response} />
                  <EndpointTestAssertions assertions={this.state.assertions} />
                </>
              )}
              {this.state.status === "error" && <div className="test-case-step-detail">{this.state.errorMessage}</div>}
            </div>
          )}
        </div>
      </>
    )
  }
}

AuthenticationTestRetrieveUserInfo.propTypes = {
  service: PropTypes.object,
  code: PropTypes.string,
  path: PropTypes.string.isRequired,
}
